import { useTranslate } from '@common/hooks'
import Button from '@common/widgets/Button'
import Dot from '@common/widgets/PaginationDot'
import cx from 'classnames'
import { useCallback, useEffect, useMemo, useState } from 'react'

import classNames from './styles.module.scss'


interface IProps {
  disabledButton: string | null
  handleMoveMainSlider: (ind: number) => void
  paginationItems: number[],
  slideNext: () => void
  slidePrev: () => void
  snapIndex: number,
  onHide: () => void,
}

export default function Pagination({
  disabledButton,
  handleMoveMainSlider,
  onHide,
  paginationItems,
  slideNext,
  slidePrev,
  snapIndex,
}: IProps): JSX.Element {
  const { translate } = useTranslate()
  const [activeElem, setActive] = useState(0)

  const onDotClick = useCallback((ind: number) => {
    handleMoveMainSlider(ind)
  }, [handleMoveMainSlider])

  const items = useMemo(() => {
    return paginationItems.map(
      (el, ind) => {
        return (
          <Dot key={ind} ind={ind} activeElem={activeElem === ind} onClick={() => onDotClick(ind)} dataTest={`dot-${ind}`}/>
        )
      }
    )
  }, [paginationItems, activeElem, onDotClick])

  useEffect(() => {
    if(activeElem !== snapIndex) {
      setActive(snapIndex)
    }
  }, [snapIndex, activeElem])

  return (
    <div className={classNames.wrapper}>
      <Button
        onClick={slidePrev}
        disabled={disabledButton === 'prev'}
        className={cx(classNames.button, classNames.prev)}
        variant="light"
        data-test="prev-btn"
      >
        {translate('Prev')}
      </Button>
      <div className={cx(classNames.pagination)}>
        {items.length > 1 && items}
      </div>
      <Button
        onClick={disabledButton === 'next' ? onHide : slideNext }
        variant={disabledButton === 'next' ? 'dark' : 'light' }
        className={cx(classNames.button, classNames.next)}
        data-test= {disabledButton === 'next' ? 'done-btn' : 'next-btn'}
      >
        {disabledButton === 'next' ? translate('Done!') : translate('Next')}
      </Button>
    </div>
  )
}
